<script setup lang="ts">
defineProps<{
  readOnly?: boolean;
  modelValue?: boolean | null;
}>();
const emit = defineEmits<{
  (e: "change", value: boolean): void;
  (e: "update:modelValue", value: boolean): void;
}>();
</script>

<template>
  <!-- TODO: eventually delete this component and use Checkbox directly -->
  <Checkbox
    binary
    :disabled="readOnly"
    :model-value="!!modelValue"
    @update:model-value="emit('update:modelValue', !modelValue)"
    @change="emit('change', !modelValue)"
  />
</template>
